import script from "./grid-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./grid-menu.vue?vue&type=script&setup=true&lang=ts"

import "./grid-menu.vue?vue&type=style&index=0&id=5724b2ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5724b2ca"]])

export default __exports__